let logs = []
let errors = []

import { config } from "./setup.js";
import SentrySDK from './connectors/sentry.js';

let loggerAPIURL;

switch (config.environment) {
    case "development":
        loggerAPIURL = "https://dev-platform.farmartos.com/api/v1/logger/add"
        break;
    case "staging":
        loggerAPIURL = "https://stage-platform.farmartos.com/api/v1/logger/add"
        break;
    case "production":
        loggerAPIURL = "https://prod-platform.farmartos.com//api/v1/logger/add"
        break;
    default:
        loggerAPIURL = "https://dev-platform.farmartos.com/api/v1/logger/add"
        break;
}

function shooter(logs, logsConfig, logType) {
    try {
        fetch(loggerAPIURL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                logPayload: {
                    index: logsConfig.index,
                    payload: logs,
                    logType
                },
                config: logsConfig
            })
        })
    } catch (error) {
        console.log(error)
    }
}

function initSentry() {
    let sentry;
    if (config.sentry && config.sentry.dsn) {
        sentry = SentrySDK.init(config.sentry);
    }
    return sentry;
}

async function logShooter(sentry) {
    try {
        setInterval(() => {
            if (logs.length > 0) {
                shooter(logs, config, "SYS")
                logs = []
            }
            if (errors.length > 0 && sentry) {
                errors.forEach(error => {
                    sentry.captureException(error.jsonPayload.err, error)
                    sentry.captureMessage(error.message, error.jsonPayload.err)
                })
                errors = []
            }
        }, 5000)
    } catch (error) {
        console.log(error)
    }
}

export { logs, errors, initSentry, logShooter }